import { faMoon, faSun, faDesktop, faGear } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '../../store/useSettingsStore';
import IconButton from '../ui/IconButton';

const THEME_ICONS = { system: faDesktop, day: faSun, night: faMoon };
const NEXT_THEME  = { system: 'day', day: 'night', night: 'system' };

const GHOST_CLASS = 'text-[color:var(--app-muted)] hover:text-emerald-500/80 hover:text-[color:var(--app-text)]';

function HeaderControls({ onOpenSettings }) {
  const { t } = useTranslation();
  const themeMode = useSettingsStore((state) => state.themeMode);
  const setThemeMode = useSettingsStore((state) => state.setThemeMode);

  return (
    <div className="flex items-center gap-2">
      <IconButton
        label="Cycle colour theme"
        icon={THEME_ICONS[themeMode] || faDesktop}
        size="md"
        border={false}
        iconClass="text-sm"
        className={GHOST_CLASS}
        onClick={() => setThemeMode(NEXT_THEME[themeMode] || 'system')}
      />
      <IconButton
        label={t('controls.settings')}
        icon={faGear}
        size="md"
        border={false}
        iconClass="text-sm"
        className={GHOST_CLASS}
        onClick={onOpenSettings}
      />
    </div>
  );
}

export default HeaderControls;